import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import { Roles } from '../../common/constants';

const states: Ng1StateDeclaration[] = [
    {
        name: 'moreTools',
        url: '/moreTools',
        component: 'wtMoreToolsState',
        abstract: false,
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.administrator, Roles.master, Roles.engineer])
        },
        data: {
            sortingOrder: 15,
            visible: true,
            icon: 'fa-wrench',
            displayName: 'More tools',
            editRoles: [],
            editButtonVisibility: () => false,
            ignoreHistory: true
        }
    }, {
        name: 'moreTools.connectionPoints',
        url: '/connectionPoints',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.master, Roles.engineer, Roles.administrator])
        },
        template:
            '<wt-connection-points-tiles class="flex-directive" selected-item="vm.selectedItem" form-controller="vm.formController" state="moreTools"></wt-connection-points-tiles>',
        data: {
            sortingOrder: 100,
            visible: false,
            displayName: 'Connection points',
            icon: 'fa-connectdevelop',
            editRoles: [Roles.administrator, Roles.master, Roles.engineer],
            editButtonVisibility: () => true,
            ignoreHistory: false
        },
        params: {
            updateDatabase: null
        }
    }, {
        name: 'moreTools.dataExportImport',
        url: '/dataExportImport',
        template: '<wt-backup-page class="flex-directive"></wt-backup-page>',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.engineer, Roles.administrator])
        },
        data: {
            sortingOrder: 300,
            visible: false,
            icon: 'fa-database',
            displayName: 'WiDE DB maintenance',
            editRoles: [Roles.engineer, Roles.administrator],
            editButtonVisibility: () => false,
            ignoreHistory: false
        }
    }, {
        name: 'moreTools.engineerinUnits',
        url: '/engineerinUnits',
        template: '<wt-variables-state class="flex-directive"></wt-variables-state>',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.engineer])
        },
        data: {
            sortingOrder: 400,
            visible: false,
            icon: 'fa-balance-scale',
            displayName: 'Engineering units',
            editRoles: [Roles.engineer],
            editButtonVisibility: () => false,
            ignoreHistory: false
        }
    }, {
        name: 'moreTools.digitalSets',
        url: '/digitalSets',
        template: require('./digitalSets/digitalSets.template.html'),
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.engineer, Roles.administrator])
        },
        data: {
            sortingOrder: 500,
            visible: false,
            icon: 'fa-list-ol',
            displayName: 'Digital sets',
            editRoles: [Roles.engineer, Roles.administrator],
            editButtonVisibility: () => true,
            ignoreHistory: false
        }
    }, {
        name: 'moreTools.states',
        url: '/states',
        template:
            '<wt-states-tiles class="flex-directive" selected-item="vm.selectedItem" form-controller="vm.formController" state-list="vm.stateList"></wt-states-tiles>',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.engineer])
        },
        data: {
            sortingOrder: 600,
            visible: false,
            icon: 'fa-barcode',
            displayName: 'States',
            editRoles: [Roles.engineer],
            editButtonVisibility: () => true,
            ignoreHistory: false
        }
    }, {
        name: 'moreTools.queries',
        url: '/queries',
        template:
            '<wt-queries-state form-controller="vm.formController" is-edit-mode="vm.isEditMode" queries="vm.queries" selected-item="vm.selectedItem" class="flex-directive"></wt-queries-state>',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.engineer])
        },
        data: {
            sortingOrder: 700,
            visible: false,
            icon: 'fa-filter',
            displayName: 'Queries',
            editRoles: [Roles.engineer],
            editButtonVisibility: () => true,
            ignoreHistory: false
        }
    }, {
        name: 'moreTools.exportConfiguration',
        url: '/exportConfiguration/:historianStorageGuid?',
        template: require('./exportConfiguration/exportConfiguration.template.html'),
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.engineer, Roles.administrator])
        },
        data: {
            sortingOrder: 800,
            visible: false,
            icon: 'fa-upload',
            displayName: 'Historian storage',
            editRoles: [Roles.engineer, Roles.administrator],
            editButtonVisibility: () => true,
            ignoreHistory: false
        },
        params: {
            historianStorageGuid: ''
        }
    }, {
        name: 'moreTools.thermoPackages',
        url: '/thermoPackages',
        template:
            '<wt-thermo-packages-list class="flex-directive"></wt-thermo-packages-list>',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.master, Roles.engineer])
        },
        data: {
            sortingOrder: 900,
            visible: false,
            icon: 'fa-flask',
            displayName: 'Thermo packages',
            ignoreHistory: false
        }
    }
];

export default states;